import { toast } from "sonner";
import { Copy, ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const HeldLinkNotice = ({ link }) => (
  <div className="space-y-2 rounded-md border border-amber-200 bg-amber-50 p-3" data-testid="held-link-notice">
    <p className="flex items-start gap-2 text-sm text-amber-800">
      <ShieldAlert className="h-4 w-4 mt-0.5 shrink-0" />
      Email hold is on for this tenant — no email was sent. The login was created; share this set-password link yourself when ready.
    </p>
    {link && (
      <div className="flex gap-2">
        <Input readOnly value={link} className="font-mono text-xs" data-testid="held-link-input" />
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => navigator.clipboard.writeText(link).then(() => toast.success("Link copied"))}
          data-testid="held-link-copy"
        >
          <Copy className="h-4 w-4" />
        </Button>
      </div>
    )}
  </div>
);
